/**
 * Last-result cache backing useLiveQueryCached: remembers the most recent
 * useLiveQuery result per key so remounting screens can render real data on their
 * first frame instead of a guaranteed undefined/skeleton frame (dexie's
 * useLiveQuery has no cache of its own).
 *
 * Bounded FIFO so long field sessions can't grow it without limit; entries are
 * only ever a re-render seed, so eviction just means one extra skeleton frame.
 */
const MAX_ENTRIES = 50;

const cache = new Map<string, unknown>();

export const liveResultCache = {
  get(key: string): unknown {
    return cache.get(key);
  },

  set(key: string, value: unknown): void {
    if (!cache.has(key) && cache.size >= MAX_ENTRIES) {
      const oldest = cache.keys().next().value;
      if (oldest !== undefined) cache.delete(oldest);
    }
    cache.set(key, value);
  },

  /** Test hook + logout hygiene: drop everything. */
  clear(): void {
    cache.clear();
  },

  size(): number {
    return cache.size;
  },
};
